module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"subscribe":"Noriu gauti Nogrid naujienlaiškį apie startuojančias APVA paramas ir kitas saulės elektrinių naujienas"}}')
  delete Component.options._Ctor
}
